import PropTypes from 'prop-types';

import { Abstrap } from '../../..';

const propTypes = { ...Abstrap.propTypes, tooltip: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    tooltip: false,
};

class FormHelp extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            tooltip,
        } = this.props;
        return [
            'c-form__help',
            tooltip ? 'c-tooltip-container c-tooltip-container--hover' : false,
            className,
        ];
    }

}

FormHelp.propTypes = propTypes;

FormHelp.defaultProps = defaultProps;

export default FormHelp;
